import React from 'react';
import './VendasDashboard.css';

const VendasDashboard = ({ summary, total_vendas =0 }) => {
  console.log('API Summary:', summary);

  if (!summary) {
    return (
        <div className="vendas-dashboard">
            <div className="dashboard-card">
                <h3>Total de Vendas</h3>
                <p>0</p>
            </div>
            <div className="dashboard-card">
                <h3>Valor Total de Transações</h3>
                <p>R$ 0,00</p>
            </div>
            <div className="dashboard-card">
                <h3>Valor Médio por Transação</h3>
                <p>R$ 0,00</p>
            </div>
            <div className="dashboard-card">
                <h3>Total Financiado</h3>
                <p>R$ 0,00</p>
            </div>
            <div className="dashboard-card">
                <h3>Valor Médio por m²</h3>
                <p>R$ 0,00</p>
            </div>
        </div>
    );
  }

  const {
    total_valor_transacao = 0,
    avg_valor_transacao = 0,
    avg_valor_m2 = 0,
    total_valor_financiado = 0
  } = summary;

  return (
    <div className="vendas-dashboard">
      <div className="dashboard-card">
        <h3>Total de Vendas</h3>
        <p>{total_vendas}</p>
      </div>
      <div className="dashboard-card">
        <h3>Valor Total de Transações</h3>
        <p>R$ {Number(total_valor_transacao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
      </div>
      <div className="dashboard-card">
        <h3>Valor Médio por Transação</h3>
        <p>R$ {Number(avg_valor_transacao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
      </div>
      <div className="dashboard-card">
        <h3>Total Financiado</h3>
        <p>R$ {Number(total_valor_financiado).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
      </div>
      <div className="dashboard-card">
        <h3>Valor Médio por m²</h3>
        <p>R$ {Number(avg_valor_m2).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
      </div>
    </div>
  );
};

export default VendasDashboard;